import get from 'lodash.get';

const getSitesLimit = (rootState) => get(rootState, 'sites.limit', null);

export default getSitesLimit;
